var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShapeBlue = function SvgShapeBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shapeBlue_svg__Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 131.8 124",
    style: {
      enableBackground: "new 0 0 131.8 124"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".shapeBlue_svg__st0{clip-path:url(#shapeBlue_svg__SVGID_00000181052084960493877700000014647458633492167843_)}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "shapeBlue_svg__SVGID_1_",
    d: "M29.1 23.8h73.5v76.4H29.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "shapeBlue_svg__SVGID_00000176042962445806192480000017043780837076274868_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shapeBlue_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#shapeBlue_svg__SVGID_00000176042962445806192480000017043780837076274868_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.8 60.2c-1.4-7.6-5.7-14.3-10.5-20.3C87 34.7 82 30 75.9 27c-3-1.4-6.3-2.8-9.6-3-3.3-.2-6.6.5-9.6 1.8-3.1 1.3-5.8 3.4-7.9 6-2.4 2.9-3.7 6.5-5.1 9.9-3.1 7.9-7.9 15-11.1 22.9-2.8 7-4.2 15-1.3 22.2 2.8 6.9 9.2 10.9 16.3 12.2 8.1 1.5 16.5-.1 24-3.3 3.8-1.6 7.4-3.5 10.9-5.6 3.5-2.1 7-4.2 10.2-6.6 3-2.2 5.5-4.8 7.2-8.1 1.6-3.2 2.3-6.7 2.3-10.2 0-1.6-.1-3.3-.4-5",
    style: {
      fill: "#004aad"
    }
  })));
};
export default SvgShapeBlue;